<template lang='pug'>
section
  v-card
    v-toolbar(flat color='white')
      h2(class='title font-weight-medium') Акции
      v-spacer
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :hide-actions='true'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название')
            div {{ props.item.name }}
            div(class="descrition") {{ props.item.description }}
          td(data-label='Время начала') {{ props.item.start_time | date }}
          td(data-label='Время завершения') {{ props.item.stop_time | date }}
          td(data-label='Статус') {{ props.item.status_name }}
          td(class='text-xs-right wrapless crud-tools')
            template(v-if='props.item.status === "draft"')
              v-btn(@click.stop='onStatus(props.item, "moderate")' flat)
                | Отправить на модерацию
            template(v-if='props.item.status === "moderate"')
              v-btn(@click.stop='onStatus(props.item, "draft")' flat)
                | В черновик
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
export default {
  data: () => ({
    headers: [
      { text: '#ID', align: 'left', value: 'id', width: '5%', sortable: false },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '0%',
        sortable: false
      },
      {
        text: 'Дата начала',
        align: 'left',
        value: 'start_time',
        width: '15%',
        sortable: false
      },
      {
        text: 'Дата завершения',
        align: 'left',
        value: 'stop_time',
        width: '15%',
        sortable: false
      },
      {
        text: 'Статус',
        align: 'left',
        value: 'status',
        width: '20%',
        sortable: false
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ]
  }),

  props: ['isLoading', 'list'],

  methods: {
    onDelete(id) {
      this.$emit('delete', id)
    },

    onEdit(id) {
      this.$emit('edit', id)
    },

    onStatus(item, status) {
      this.$emit('status', { item, status })
    }
  }
}
</script>

<style scoped>
.descrition {
  margin-top: 10px;
  font-size: 10px;
  color: gray;
}
</style>
